import './SecureCheckoutComponent.scss';
import {ImageConfig} from "../../../constants";
import ClientAndProviderDetailsCardComponent
    from "../../../shared/components/client-and-provider-details-card/ClientAndProviderDetailsCardComponent";
import React, {useCallback, useEffect, useState} from "react";
import ServiceDetailsCardComponent
    from "../../../shared/components/service-details-card-component/ServiceDetailsCardComponent";
import CommonService from "../../../shared/services/common.service";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import InputComponent from "../../../shared/components/form-controls/input/InputComponent";
import CheckBoxComponent from "../../../shared/components/form-controls/check-box/CheckBoxComponent";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {useNavigate} from "react-router-dom";
import LoaderComponent from "../../../shared/components/loader/LoaderComponent";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import AttendanceAndCancellationPolicyComponent
    from "../attendance-and-cancellation-policy/AttendanceAndCancellationPolicyComponent";
import ServiceCategoryReadMoreComponent from "../service-category-details/ServiceCategoryReadMoreComponent";
import moment from "moment/moment";

interface SecureCheckoutComponentProps {
    appointmentDetails?: any;
    isComingFromListScreen: boolean;
    setIsSecureCheckOutModalOpen: any;
    selectedId?: string;
    setRefreshToken?: any;
    location?: string;
    refreshPaymentList?: any;
}

const SecureCheckoutComponent = (props: SecureCheckoutComponentProps) => {

    const {
        appointmentDetails,
        setIsSecureCheckOutModalOpen,
        setRefreshToken,
        isComingFromListScreen,
        selectedId,
        location,
        refreshPaymentList
    } = props;

    const [payType] = useState<'checkout'>('checkout');
    const [couponCode, setCouponCode] = useState<string>('');
    const [selectedCoupon, setSelectedCoupon] = useState<any>(undefined);
    const [discountAmount, setDiscountAmount] = useState<number>(0);
    const [payableAmount, setPayableAmount] = useState<number>(0);
    const [couponApplyButtonText, setCouponApplyButtonText] = useState<string>('Apply');
    const [isCouponApplyInProgress, setIsCouponApplyInProgress] = useState<boolean>(false);
    const [isAttendancePolicyChecked, setIsAttendancePolicyChecked] = useState<boolean>(false);
    const [isCheckingOutInProgress, setIsCheckingOutInProgress] = useState<boolean>(false);
    const navigate = useNavigate();
    const [appointmentData, setAppointmentData] = useState<any>(null);
    const [isDetailsLoading, setIsDetailsLoading] = useState<boolean>(false);
    const [isAttendanceModalOpen, setIsAttendanceModalOpen] = useState(false);
    const finalAppointmentDetails = isComingFromListScreen ? appointmentData : appointmentDetails;
    const [openModal, setOpenModal] = useState<boolean>(false);


    console.log('finalAppointmentDetails', finalAppointmentDetails);

    const handleCouponAvailability = useCallback(() => {
        setIsCouponApplyInProgress(true);
        try {
            const payload = {
                service_id: finalAppointmentDetails?.service_id,
                amount: finalAppointmentDetails?.payable_amount,
                coupon_code: couponCode
            };
            CommonService._transaction.VerifyCoupon(payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsCouponApplyInProgress(false);
                    setCouponApplyButtonText('Applied!');
                    if (response?.data) {
                        setSelectedCoupon(response.data);
                        if (response.data.discount_type === 'amount') {
                            setDiscountAmount(response.data.amount);
                            const totalPayableAmount = finalAppointmentDetails?.payable_amount - response.data.amount;
                            setPayableAmount(totalPayableAmount);
                        } else {
                            let totalPayableAmount;
                            const finalDiscountAmount = CommonService.calculateFinalAmountFromDiscountPercentage(response.data.percentage, finalAppointmentDetails?.payable_amount);
                            setDiscountAmount(finalDiscountAmount);
                            if (finalDiscountAmount > response.data.max_discount_amount) {
                                totalPayableAmount = finalAppointmentDetails?.payable_amount - response.data.max_discount_amount;
                            } else {
                                totalPayableAmount = finalAppointmentDetails?.payable_amount - finalDiscountAmount;
                            }
                            setPayableAmount(totalPayableAmount);
                        }
                    }
                })
                .catch((error: any) => {
                    setIsCouponApplyInProgress(false);
                    setCouponApplyButtonText('Apply');
                    CommonService._alert.showToast(error?.errors?.coupon_code?.[0] || error.error, 'error')
                });
        } catch (error) {
            console.error("An error occurred in handleCouponAvailability:", error);
        }
    }, [finalAppointmentDetails, couponCode]);

    const handleSecureCheckout = useCallback(() => {
        setIsCheckingOutInProgress(true);
        const payload = {
            service_id: finalAppointmentDetails?.service_id,
            coupon_code: couponCode,
            payment_mode: 'credit_card',
            amount: selectedCoupon
                ? CommonService.convertToDecimals(payableAmount)
                : CommonService.convertToDecimals(+finalAppointmentDetails?.payable_amount),
        }
        CommonService._transaction.InvoicePayment(finalAppointmentDetails?._id, payload)
            .then((response: IAPIResponseType<any>) => {
                setIsCheckingOutInProgress(false);
                setIsSecureCheckOutModalOpen(false);
                if (location === 'dashboard') {
                    refreshPaymentList()
                    navigate(CommonService._routeConfig.Dashboard())
                } else if (location === 'appointments') {
                    setRefreshToken && setRefreshToken(Math.random());
                    navigate(CommonService._routeConfig.AppointmentList());
                    refreshPaymentList()
                } else if (location === 'appointmentList') {
                    setRefreshToken && setRefreshToken(Math.random());
                } else {
                    navigate(CommonService._routeConfig.Transaction())
                }
                setCouponCode('');
                setCouponApplyButtonText('Apply');
                setSelectedCoupon(undefined);
                CommonService._alert.showToast('Payment successful', 'success');
                setRefreshToken && setRefreshToken(Math.random());

            })
            .catch((error: any) => {
                setIsCheckingOutInProgress(false);
                console.log('error', error)
                // CommonService._alert.showToast(error.error, 'error')
            })


    }, [finalAppointmentDetails, location, refreshPaymentList, setRefreshToken, navigate, couponCode, selectedCoupon, payableAmount, setIsSecureCheckOutModalOpen]);

    const fetchTransactionDetails = useCallback((transactionId: string) => {
        try {
            setIsDetailsLoading(true);
            CommonService._transaction.GetInvoiceDetails(transactionId)
                .then((response: any) => {
                    setAppointmentData(response.data);
                    setIsDetailsLoading(false);
                }).catch((error: any) => {
                setIsDetailsLoading(false);
                setAppointmentData(null)
                console.log(error);
            })
        } catch (error) {
            setIsDetailsLoading(false);
        }

    }, []);

    useEffect(() => {
        if (selectedId && isComingFromListScreen) {
            fetchTransactionDetails(selectedId);
        }
    }, [selectedId, fetchTransactionDetails, isComingFromListScreen]);

    const handleClose = () => {
        setIsSecureCheckOutModalOpen(false);
        setCouponCode('');
        setCouponApplyButtonText('Apply');
        setSelectedCoupon(undefined);
    }

    return (
        <div className={"secure-checkout-component"}>
            {
                isComingFromListScreen && isDetailsLoading && <LoaderComponent/>
            }
            <div className="appointment-details-secure-checkout_modal-container ">

                {
                    !isDetailsLoading && <>
                        <div className="appointment-details_modal__left-container ts-col-lg-6 ts-col-md-12 ts-col-sm-12">
                            <div
                                className="appointment-details_modal__left-container-header__wrapper ts-col-lg-12 ts-col-md-12 ts-col-sm-12">
                                <div className="appointment-details_modal__left-container__title">Appointment Details</div>
                                {finalAppointmentDetails?.payment_for !== 'products' &&
                                    <div className="appointment-details_modal__left-container__button_section">
                                        <div className="appointment-details_modal__left-container__button">
                                            {finalAppointmentDetails?.appointment_type === 'followup_consultation' ? 'Followup Consultant' : 'Initial Consult'}
                                        </div>
                                        &nbsp;&nbsp;
                                        <div className="appointment-details_modal__left-container__button">
                                            <span><ImageConfig.TimerIcon/></span>
                                            {finalAppointmentDetails?.appointment_details?.duration || finalAppointmentDetails?.duration} min
                                        </div>
                                    </div>}
                            </div>
                            <div className={'client-details-card '}>
                                Client: {finalAppointmentDetails?.client_details?.first_name + " " + finalAppointmentDetails?.client_details?.last_name} | {CommonService.formatPhoneNumber(finalAppointmentDetails?.client_details?.primary_contact_info?.phone)}
                            </div>
                            {
                                finalAppointmentDetails?.record_type === "performance_record" &&
                                <div className={''}>
                                    {finalAppointmentDetails?.payment_for !== 'products' && <>
                                        <ServiceDetailsCardComponent setModalOpen={setOpenModal}
                                                                     serviceDetails={finalAppointmentDetails}/>
                                        <ClientAndProviderDetailsCardComponent type={'facility'}
                                                                               facility={finalAppointmentDetails?.facility_details}/>
                                    </>
                                    }
                                    <div className={'session-details-card'}>
                                        <div className={'total-appointments'}>Total
                                            Appointments: {finalAppointmentDetails?.sessions?.length}</div>
                                        <table className="appointment-table">
                                            <thead>
                                            <tr>
                                                <th>Provider</th>
                                                <th>Date</th>
                                                <th>Time</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {finalAppointmentDetails?.sessions.map((session: any, index: number) => (
                                                <tr key={index}>
                                                    <td>{session.provider_details?.first_name + " " + session.provider_details?.last_name}</td>
                                                    <td>{moment(session.appointment_date).format('DD/MM/YYYY')}</td>
                                                    <td>{CommonService.getHoursAndMinutesFromMinutes(session.start_time)}</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            }
                            {finalAppointmentDetails?.record_type !== "performance_record" &&
                                <div className={'ts-col-lg-12 ts-col-md-12 ts-col-sm-12'}>
                                    {finalAppointmentDetails?.payment_for !== 'products' &&
                                        <ServiceDetailsCardComponent setModalOpen={setOpenModal}
                                                                     serviceDetails={finalAppointmentDetails}/>}
                                    <ClientAndProviderDetailsCardComponent type={'facility'}
                                                                           facility={finalAppointmentDetails?.facility_details}/>
                                    <ClientAndProviderDetailsCardComponent type={'provider'}
                                                                           provider={finalAppointmentDetails?.provider_details}/>
                                    {finalAppointmentDetails?.payment_for !== 'products' &&
                                        <ClientAndProviderDetailsCardComponent type={'time'}
                                                                               appointmentDate={finalAppointmentDetails?.appointment_date}
                                                                               appointmentTime={finalAppointmentDetails?.appointment_details?.start_time}/>
                                    }

                                </div>
                            }
                        </div>
                        <div className="appointment-details_modal__right-container  ts-col-lg-6 ts-col-md-12 ts-col-sm-12">
                            {payType === 'checkout' &&
                                <div className="modal-close-button" onClick={() => handleClose()}>
                                    <ImageConfig.CloseIcon/>
                                </div>
                            }
                            <div className="appointment-details_modal__right-container_title">
                                {payType === 'checkout' ? 'Secure Checkout' : 'Select Payment Method'}
                            </div>
                            {payType === 'checkout' &&
                                <div className="checkout-payment-details__info__wrapper">
                                    <div className={'checkout-payment-details-header__info grand-total'}>
                                        <div className={'checkout-payment-details-header__info__label'}>
                                            Total Amount (Incl. tax)
                                        </div>
                                        <div className={'checkout-payment-details-header__info__value'}>
                                            ${finalAppointmentDetails?.discount ? CommonService.convertToDecimals(finalAppointmentDetails?.total - finalAppointmentDetails?.discount) : CommonService.convertToDecimals(finalAppointmentDetails?.total) || 'N/A'}
                                        </div>
                                    </div>
                                    <div className={'checkout-payment-details__promotion_code_wrapper'}>
                                        <div className="promotion_code_text_msg">Add a gift card or promotion code or
                                            voucher
                                        </div>
                                        <div className="promotion_code_input_wrapper">
                                            <InputComponent fullWidth={true} value={couponCode}
                                                            onChange={(value: any) => {
                                                                if (value) {
                                                                    setCouponCode(value.toUpperCase());
                                                                } else {
                                                                    setCouponCode('');
                                                                    setCouponApplyButtonText('Apply');
                                                                    setSelectedCoupon(undefined)
                                                                }
                                                            }}
                                                            placeholder="Enter code"/>
                                            <ButtonComponent onClick={handleCouponAvailability}
                                                             disabled={!couponCode}
                                                             isLoading={isCouponApplyInProgress}
                                                             className={'button-apply-code'}
                                                             variant={'outlined'}
                                                             color={'accent'}>
                                                {couponApplyButtonText}
                                            </ButtonComponent>

                                        </div>

                                        <div className={'checkout-payment-details__sub-section-breakup-summary'}>
                                            <div className="checkout-payment-details__title">Checkout Summary</div>
                                            <div className={'checkout-payment-details__info gross-total'}>
                                                <div className={'checkout-payment-details__info__label'}>
                                                    Amount (Incl. tax)
                                                </div>
                                                <div className={'checkout-payment-details__info__value'}>
                                                    ${finalAppointmentDetails?.discount ? CommonService.convertToDecimals(finalAppointmentDetails?.total - finalAppointmentDetails?.discount) : CommonService.convertToDecimals(finalAppointmentDetails?.total) || 'N/A'}
                                                </div>
                                            </div>
                                            <div className={'checkout-payment-details__info discount'}>
                                                <div className={'checkout-payment-details__info__label'}>
                                                    Discount
                                                </div>
                                                <div className={'checkout-payment-details__info__value'}>
                                                    {selectedCoupon ? `- $${CommonService.convertToDecimals(discountAmount)}` :
                                                        <div
                                                            className={'zero-discount'}>$0.00</div> || 'N/A'}
                                                </div>
                                            </div>
                                            <div className={'checkout-payment-details__info net-amount'}>
                                                <div className={'payment-details__info__label'}>
                                                    Total Amount (Incl. tax)
                                                </div>
                                                <div className={'payment-details__info__value'}>
                                                    ${selectedCoupon ? CommonService.convertToDecimals(payableAmount) : CommonService.convertToDecimals(+finalAppointmentDetails?.payable_amount)}
                                                </div>
                                            </div>
                                            <div className={'attendance-and-cancellation-policy'}>
                                                <CheckBoxComponent label={''}
                                                                   value={isAttendancePolicyChecked}
                                                                   checked={isAttendancePolicyChecked}
                                                                   onChange={() => setIsAttendancePolicyChecked(prev => !prev)}
                                                />
                                                <div className={'attendance-and-cancellation-policy__label'}> Reviewed
                                                    the&nbsp;
                                                    <span className={'blue-text'}
                                                          onClick={() => {
                                                              setIsAttendanceModalOpen(true);
                                                          }}>Attendance/Cancellation Policy.</span>
                                                </div>
                                            </div>

                                        </div>
                                        <div>
                                            <ButtonComponent
                                                disabled={!isAttendancePolicyChecked}
                                                className={'mrg-top-40'}
                                                onClick={handleSecureCheckout}
                                                isLoading={isCheckingOutInProgress}
                                                fullWidth={true}>
                                                Check Out
                                            </ButtonComponent>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </>
                }
            </div>

            <div className={'modal-wrapper'}>
                <ModalComponent isOpen={isAttendanceModalOpen}
                                closeOnBackDropClick={true}
                                onClose={() => setIsAttendanceModalOpen(false)}
                >
                    <AttendanceAndCancellationPolicyComponent setIsAttendanceModalOpen={setIsAttendanceModalOpen}/>
                </ModalComponent>
            </div>
            <div>
                <ModalComponent isOpen={openModal}>
                    <ServiceCategoryReadMoreComponent appointmentDetails={finalAppointmentDetails}
                                                      setOpenModal={setOpenModal}
                    />
                </ModalComponent>
            </div>

        </div>
    )
}

export default SecureCheckoutComponent;
